<template>
    <div class="gst-breadcrumbs">
        <span
            v-for="(item, index) in i18nKeys"
            :key="index">
            <v-icon
                v-if="index > 0"
                size="20">
                mdi-chevron-right
            </v-icon>
            <span>{{ $t(item) }}</span>
        </span>
    </div>
</template>
<script>
export default {
    name: 'Breadcrumbs',
    props: {
        //i18nKeys or values
        i18nKeys: {
            type: Array,
            required: true,
        },
    },
};
</script>
<style lang="scss">
@import '@scssVariables';

.gst-breadcrumbs {
    font-weight: font-weight('medium');
    font-size: font-size('s');
    color: theme-color('septenary');

    span {
        display: inline-block;
        vertical-align: middle;
    }
}
</style>
